import React, { useEffect, useState } from "react";
import httpService from "../../../services/http/peoples/shoppers.service";
import UnlimitInput from "../../../components/ui-kit/unlimit-input";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { all_routes } from "../../../Router/all_routes";
import notificationService from "../../../services/toaster.service";
import { Link } from "react-router-dom/dist";
import UnlimitSelect from "../../../components/ui-kit/unlimit-select";
import { hydrateErrors } from "../../../utils/error.utils";
import UnlimitLoading from "../../../components/ui-kit/unlimit-loading";
import UnlimitSubmitButton from "../../../components/ui-kit/unlimit-submit-button";
import UnlimitBreadcrumb from "../../../components/ui-kit/unlimit-breadcrumb";
import { useTranslation } from "react-i18next";
import useRoleAndPerm from "../../../utils/permissionFunction";
import { useSelector } from "react-redux";

const ShopperForm = () => {
    const { hasPermission, getRedirectLink } = useRoleAndPerm();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(false);
    const [pageLoading, setPageLoading] = useState(false);
    const companies = useSelector((state) => state.companies.companies);
    const shopperLink = getRedirectLink("shopper");
    console.log(shopperLink);
    
    const { register, handleSubmit, formState, setValue, control, setError } =
        useForm();
    const { errors } = formState;
    const { id } = useParams();
    const [companyList, setCompanyList] = useState([]);
    const [titleOptions] = useState([
        { label: "Mr.", value: "Mr." },
        { label: "Mrs.", value: "Mrs." },
        { label: "Ms.", value: "Ms." },
    ]);

    const hydratePredefinedValues = (data) => {
        setValue("lm_shopper_number", data.lm_shopper_number);
        setValue("title", data.title);
        setValue("first_name", data.first_name);
        setValue("last_name", data.last_name);
        setValue("email", data.email);
        setValue("phone", data.phone);

        /** set selected company **/
        if (data.company?.id) {
            setCompanyList((prevCompanies) => {
                let company = prevCompanies.find(
                    (item) => item.id == data?.company?.id
                );
                if (company) {
                    company = {
                        ...company,
                        label: company.business_name,
                        value: company.id,
                    };
                    setValue("company_id", company);
                }
                return prevCompanies;
            });
        }

        /** set selected title **/
        if (data.title) {
            const title = titleOptions.find((option) => option.value === data.title);
            if (title) {
                setValue("title", title);
            }
        }
    };

    const getShopper = async () => {
        try {
            setPageLoading(true);
            await httpService
                .getShopper(id)
                .then((response) => {
                    if (response && response.status === 200) {
                        const data = response.data.data;
                        hydratePredefinedValues(data);
                    }
                })
                .catch((error) => {
                    console.error("Error:", error);
                });
        } finally {
            setPageLoading(false);
        }
    };

    const fetchPredefinedValues = async () => {
        setCompanyList(companies?.data?.data ?? []);
        if (id) {
            await getShopper();
        }
    };

    useEffect(() => {
        fetchPredefinedValues();
    }, [id]);

    const onSubmitForm = async (data) => {
        try {
            setIsLoading(true);
            const formData = {
                lm_shopper_number: data.lm_shopper_number,
                title: data.title?.value || data.title,
                first_name: data.first_name,
                last_name: data.last_name,
                email: data.email,
                phone: data.phone || "",
                company_id: data.company_id?.id || data.company_id,
            };

            if (id) {
                formData.id = id;
                await updateShopper(formData);
            } else {
                await createShopper(formData);
            }
        } finally {
            setIsLoading(false);
        }
    };

    const updateShopper = async (formData) => {
        await httpService
            .updateShopper(formData)
            .then((response) => {
                if (response.status === 200) {
                    notificationService.successMessage(t("shopper.shopperUpdateSuccess"));
                    navigate(all_routes.shoppersList);
                }
            })
            .catch((error) => {
                if (error.validation_error?.errors) {
                    hydrateErrors(error.validation_error.errors, setError);
                }
            });
    };

    const createShopper = async (formData) => {
        try {
            await httpService
                .createShopper(formData)
                .then((response) => {
                    if (response && response.status === 200) {
                        notificationService.successMessage(
                            t("shopper.shopperCreateSuccess")
                        );
                        navigate(all_routes.shoppersList);
                    }
                })
                .catch((error) => {
                    if (error.validation_error?.errors) {
                        hydrateErrors(error.validation_error.errors, setError);
                    }
                    console.error("Error:", error);
                });
        } catch (error) {
            if (error.validation_error?.errors) {
                hydrateErrors(error.validation_error.errors, setError);
            }
        }
    };

    const breadcrumbItems = [
        { label: "", link: "/", icon: "feather-home" },
        { label: t("shopper.shopper"), link: "/shoppers-list" },
        {
            label: id ? t("shopper.editShopper") : t("shopper.addShopper"),
            active: true,
        },
    ];

    return (
        <div className="page-wrapper">
            <div className="content">
                <div className="page-header">
                    <div className="add-item d-flex flex-column">
                        <div className="page-title">
                            <h4>
                                {id ? t("shopper.editShopper") : t("shopper.addNewShopper")}
                            </h4>
                        </div>
                        <UnlimitBreadcrumb items={breadcrumbItems} />
                    </div>
                </div>
                {/* /add */}
                <form onSubmit={handleSubmit(onSubmitForm)}>
                    <div className="card">
                        <div className="card-body pb-0">
                            {pageLoading ? (
                                <div className="row d-flex justify-content-center">
                                    <UnlimitLoading width={50} height={50} />
                                </div>
                            ) : (
                                <div>
                                    <div className="row mb-4">
                                        <div className="col-md-12">
                                            <h4 className="mb-0">Add New Shopper</h4>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <UnlimitSelect
                                                label={t("company.company")}
                                                id="company_id"
                                                errors={errors}
                                                control={control}
                                                register={register}
                                                rules={{
                                                    required: t("inputField.validation.required"),
                                                }}
                                                placeholder={t("inputField.placeholder.chooseCompany")}
                                                options={companies?.data?.data ?? []}
                                                showLogo={true}
                                                optionLabel="business_name"
                                                optionValue="id"
                                            />
                                        </div>
                                    </div>
                                    <div className="row mt-4">
                                        <div className="col-md-3">
                                            <UnlimitInput
                                                label={t("inputField.label.lmUserID")}
                                                id="lm_shopper_number"
                                                type="number"
                                                placeholder="Enter User ID"
                                                register={register}
                                                rules={{
                                                    required: t("inputField.validation.required"),
                                                }}
                                                error={errors.lm_shopper_number}
                                                errorMessage={errors.lm_shopper_number?.message}
                                            />
                                        </div>
                                        <div className="col-md-3">
                                            <UnlimitSelect
                                                label={t("inputField.label.title")}
                                                id="title"
                                                errors={errors}
                                                control={control}
                                                register={register}
                                                placeholder="Mr./Mrs."
                                                options={titleOptions}
                                            />
                                        </div>
                                        <div className="col-md-3">
                                            <UnlimitInput
                                                label={t("inputField.label.firstName")}
                                                id="first_name"
                                                type="text"
                                                placeholder="Enter First Name"
                                                register={register}
                                                rules={{
                                                    required: t("inputField.validation.required"),
                                                    pattern: {
                                                        value: /^[A-Za-z\s\-',.*&@]+$/,
                                                        message: t("inputField.validation.namePattern"),
                                                    },
                                                    maxLength: {
                                                        value: 50,
                                                        message: t("inputField.validation.maxLength", {
                                                            value: 50,
                                                        }),
                                                    },
                                                }}
                                                error={errors.first_name}
                                                errorMessage={errors.first_name?.message}
                                            />
                                        </div>
                                        <div className="col-md-3">
                                            <UnlimitInput
                                                label={t("inputField.label.surname")}
                                                id="last_name"
                                                type="text"
                                                placeholder="Enter surname"
                                                register={register}
                                                rules={{
                                                    required: t("inputField.validation.required"),
                                                    pattern: {
                                                        value: /^[A-Za-z\s\-',.*&@]+$/,
                                                        message: t("inputField.validation.namePattern"),
                                                    },
                                                    maxLength: {
                                                        value: 50,
                                                        message: t("inputField.validation.maxLength", {
                                                            value: 50,
                                                        }),
                                                    },
                                                }}
                                                error={errors.last_name}
                                                errorMessage={errors.last_name?.message}
                                            />
                                        </div>
                                    </div>
                                    <div className="row mt-4">
                                        <div className="col-md-3">
                                            <UnlimitInput
                                                label={t("inputField.label.email")}
                                                id="email"
                                                type="email"
                                                placeholder="Enter Email"
                                                register={register}
                                                rules={{
                                                    required: t("inputField.validation.required"),
                                                    pattern: {
                                                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                                        message: t("inputField.validation.emailPattern"),
                                                    },
                                                }}
                                                error={errors.email}
                                                errorMessage={errors.email?.message}
                                            />
                                        </div>
                                        <div className="col-md-3">
                                            <UnlimitInput
                                                label={
                                                    t("inputField.label.phone") +
                                                    " (" +
                                                    t("general.optional") +
                                                    ")"
                                                }
                                                id="phone"
                                                type="text"
                                                placeholder="Enter Phone"
                                                register={register}
                                                rules={{
                                                    pattern: {
                                                        value: /^(?:\+|00)?[\d\s\-()]+$/,
                                                        message: t("inputField.validation.phonePattern"),
                                                    },
                                                    maxLength: {
                                                        value: 20,
                                                        message: t("inputField.validation.maxLength", {
                                                            value: 20,
                                                        }),
                                                    },
                                                }}
                                                error={errors.phone}
                                                errorMessage={errors.phone?.message}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-12 mb-4 mt-4">
                                        <Link to={all_routes.shoppersList} className="me-2">
                                            <button type="button" className="btn btn-cancel">
                                                {t("general.button.cancel")}
                                            </button>
                                        </Link>
                                        <UnlimitSubmitButton
                                            label={
                                                id
                                                    ? t("general.button.update")
                                                    : t("general.button.submit")
                                            }
                                            isLoading={isLoading}
                                        />
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </form>
                {/* /add */}
            </div>
        </div>
    );
};

export default ShopperForm;
